import Button from "react-bootstrap/Button";
import './index.css'

interface PlaceOrderButtonProps {
    title?: string;
    isDisabled?: boolean;
    type?: any;
    onClick?: any;
    icon?: any;
    color?: string;
    style?: React.CSSProperties; 
}

//buttons that we frequently used
const PlaceOrderButton: React.FC<PlaceOrderButtonProps> = ({ title, isDisabled, type, onClick, icon, color }) => {
    return (<>
        <Button className='buttonColor' disabled={isDisabled} type={type} onClick={onClick} color={`${color}`}>
            <div className="long-button-container">
                {icon} &nbsp;
                {title}
            </div>
        </Button>
    </>)
}

export default PlaceOrderButton;